import { defineComponent as _defineComponent } from 'vue'
import ToolTipIcon from '@/components/info/ToolTipIcon';
import Chevron from '@/components/interface/Chevron';
import { IconType } from '@/lib/enum/Icon';
import {
  AccordionBoxHeaderColourEnum,
  AccordionBoxTogglePositionEnum,
} from '@/types/propTypes';
import { ref } from 'vue';

/**
 * Base component for an accordion.
 *
 * `heading` property is used to define the header for the box
 *
 * `closed` boolean property to define whether the box should default to an open or closed state.
 *
 *  `togglePosition` property defines if the toggle is below or above the content
 *
 * Use the `default` slots to fill any number of components within the box. This is typically used within the `Sidebar`
 * components and `Checkbox` components as a filter.
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionBox',
  props: {
    heading: { default: '' },
    subHeading: { default: '' },
    headerColour: { default: AccordionBoxHeaderColourEnum.White },
    closed: { type: Boolean, default: false },
    togglePosition: { default: AccordionBoxTogglePositionEnum.Top },
    tooltip: { default: '' },
    iconLeft: { default: null },
    disabled: { type: Boolean, default: false },
    hoverEffect: { type: Boolean, default: false },
    hidden: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { heading: string, subHeading: string, headerColour: AccordionBoxHeaderColourEnum, closed: boolean, togglePosition: AccordionBoxTogglePositionEnum, tooltip: string, iconLeft: IconType | null, disabled: boolean, hoverEffect: boolean, hidden: boolean }



const open = ref<number[]>(props.closed ? [1] : [0]);

return { __sfc: true,props, open, ToolTipIcon, Chevron, AccordionBoxHeaderColourEnum, AccordionBoxTogglePositionEnum }
}

})